export default "__VITE_ASSET__CVUwtYoa__"